import { createSlice } from '@reduxjs/toolkit'

export const searchSlice = createSlice({
  name: 'search',
  initialState: {
    keyword: '',
    resultItems: [],
    fullResultItems: [],
    totalCount: 0,
    loading: false,
    startIndex: 0,
  },
  reducers: {
    setKeyword: (state, action) => {
      state.keyword = action.payload
    },
    setResults: (state, action) => {
      state.resultItems = action.payload
    },
    setTotalCount: (state, action) => {
      state.totalCount = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setFullResults: (state, action) => {
      state.fullResultItems = action.payload
    },
    setStartIndex: (state, action) => {
      state.startIndex = action.payload
    },
  },
})

export const { setKeyword, setResults, setTotalCount, setLoading, setFullResults, setStartIndex } = searchSlice.actions

export default searchSlice.reducer
